import React from 'react';
import DateRangeSelector from '../../common/DateRangeSelector';
import {
  Button,
  Box,
  Stack,
  TextField,
  MenuItem,
  Typography,
} from '@mui/material';
import AdvancedFiltersContainer from '../../common/AdvancedFiltersContainer';

/* Generates the Search Tools for querying data */
const InvoiceFilters = ({
  clearFilters,
  accessLevel,
  accessType,
  handleInputChange,
  handleUserDataSearch,
  customerTypeFilterDropdown,
  statusFilterDropdown,
  currentlySearching,
  selectorKeyRefresh,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  filters,
}) => {
  const statusDropdown = () => {
    const invoiceStatus = [
      'All',
      'Invoiced',
      'Paid',
      'Failed',
      'Pending',
      'Paid - Manual',
      'Refund',
      'Cancelled',
    ];

    return (
      <TextField
        id="statusFilter"
        name="statusFilter"
        fullWidth
        value={statusFilterDropdown || ''}
        onChange={(e) => handleInputChange(e)}
        select
        size="small"
        label="Status">
        {!statusFilterDropdown && (
          <MenuItem disabled value="">
            Select Status
          </MenuItem>
        )}
        {invoiceStatus.map((status) => (
          <MenuItem key={status} value={status}>
            {status}
          </MenuItem>
        ))}
      </TextField>
    );
  };

  // Generates the dropdown for customer type filter
  const customerTypeDropdown = () => {
    return (
      <TextField
        id="customerTypeFilter"
        name="customerTypeFilter"
        select
        size="small"
        fullWidth
        value={customerTypeFilterDropdown || ''}
        onChange={(e) => handleInputChange(e)}
        label="Type">
        {!customerTypeFilterDropdown && (
          <MenuItem disabled value="">
            Select type
          </MenuItem>
        )}
        <MenuItem key={'pre-paid'} value={'B'}>
          Pre-paid
        </MenuItem>
        <MenuItem key={'post-paid'} value={'A'}>
          Post-paid
        </MenuItem>
      </TextField>
    );
  };

  const isGod = accessLevel === '3' && accessType === '3';
  const providerContent = isGod && (
    <TextField
      label="Provider"
      id="providerFilter"
      name="providerFilter"
      onChange={(e) => handleInputChange(e)}
      placeholder="Search Provider"
      size="small"
      fullWidth
      value={filters?.providerFilter || ''}
    />
  );

  const customerContent = isGod && (
    <TextField
      label="Customer"
      id="customerFilter"
      name="customerFilter"
      onChange={(e) => handleInputChange(e)}
      placeholder="Search Customer"
      size="small"
      fullWidth
      value={filters?.customerFilter || ''}
    />
  );

  const currencyContent = isGod && (
    <TextField
      label="Currency"
      id="currencyFilter"
      name="currencyFilter"
      onChange={(e) => handleInputChange(e)}
      placeholder="Search Currency"
      size="small"
      fullWidth
      value={filters?.currencyFilter || ''}
    />
  );

  // Destructures which filters the table is currently displaying fields on.
  let {
    providerFilter,
    invoiceFilter,
    customerFilter,
    statusFilter,
    currencyFilter,
    customerTypeFilter,
  } = currentlySearching || {};

  let filterText = [];
  let values = [];
  values = ['Invoice:', 'Status:'];
  let filterArray = [invoiceFilter, statusFilter];
  if (isGod) {
    let typeFilterText = '';
    if (customerTypeFilter === 'A') typeFilterText = 'Post-paid';
    if (customerTypeFilter === 'B') typeFilterText = 'Pre-paid';

    values = [
      'Provider:',
      'Customer:',
      'Invoice No:',
      'Status:',
      'Currency:',
      'Type:',
    ];
    filterArray = [
      providerFilter,
      customerFilter,
      invoiceFilter,
      statusFilter,
      currencyFilter,
      typeFilterText,
    ];
  }

  // Pushes spans to an array for rendering. Iterates to avoid code duplication.
  filterArray.map((filter, i) => {
    if (filter)
      filterText.push(
        <span key={i}>
          {filterText.length === 0 ? '' : '; '} <b>{values[i]}</b> {filter}
        </span>
      );
  });

  return (
    <Box>
      <DateRangeSelector
        key={selectorKeyRefresh ? 1 : 0}
        handleDateSearch={(fromDate, toDate, timeRange) =>
          handleUserDataSearch(fromDate, toDate, timeRange)
        }
        parentStartDate={fromDate}
        setParentStartDate={setFromDate}
        parentEndDate={toDate}
        setParentEndDate={setToDate}
      />

      <AdvancedFiltersContainer>
        <Box
          sx={{
            maxWidth: { lg: 674 },
          }}>
          <form id="filter-form">
            <Stack
              sx={{
                flexDirection: { lg: 'row' },
                gap: 2,
                marginY: 2,
              }}>
              <Stack>
                <Typography sx={{ whiteSpace: 'nowrap', marginTop: 1 }}>
                  By Field:
                </Typography>
              </Stack>

              <Stack sx={{ gap: 1, flex: 1 }}>
                <Stack
                  sx={{
                    flexDirection: { lg: 'row' },
                    gap: 2,
                    alignItems: { lg: 'center' },
                  }}>
                  {providerContent}

                  <TextField
                    label="Invoice No"
                    id="invoiceFilter"
                    name="invoiceFilter"
                    onChange={(e) => handleInputChange(e)}
                    placeholder="Search Invoice No"
                    size="small"
                    fullWidth
                  />

                  {statusDropdown()}
                </Stack>
                <Stack
                  sx={{
                    flexDirection: { lg: 'row' },
                    gap: 2,
                    alignItems: { lg: 'center' },
                  }}>
                  {customerContent}
                  {currencyContent}

                  {isGod && customerTypeDropdown()}
                </Stack>
              </Stack>
            </Stack>

            {filterText.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                }}>
                <Button variant="link" color="secondary" onClick={clearFilters}>
                  Clear Filters
                </Button>
              </Box>
            )}
          </form>
        </Box>
      </AdvancedFiltersContainer>

      <Box sx={{ display: 'flex', gap: 2, marginTop: 2 }}>
        {filterText.length > 0 && <Typography>{filterText}</Typography>}
      </Box>
    </Box>
  );
};

export default InvoiceFilters;
